<div class="confirm-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ data.title }}</h2>
  </div>
  
  <div mat-dialog-content class="dialog-content">
    <p class="confirmation-message">{{ data.message }}</p>
  </div>
  
  <div mat-dialog-actions class="dialog-actions">
    <button 
      mat-button 
      (click)="onCancel()" 
      class="cancel-button"
      cdkFocusInitial>
      {{ data.cancelText || 'Cancel' }}
    </button>
    <button 
      mat-raised-button 
      color="warn" 
      (click)="onConfirm()" 
      class="confirm-button">
      {{ data.confirmText || 'Confirm' }}
    </button>
  </div>
</div>
